import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7458f16a")

_pushScopeId("data-v-7458f16a")
const _hoisted_1 = { class: "my-shift-time-container mb-32" }
const _hoisted_2 = { class: "mt-12 font-size-18" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "mr-6" }
const _hoisted_5 = { class: "flex mt-2" }
const _hoisted_6 = { class: "mr-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_8 = { class: "flex mt-12 justify-between" }
const _hoisted_9 = { class: "mb-4 mt-6 flex items-baseline justify-end" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "hope-shift mr-1" }, null, -1)
const _hoisted_11 = { class: "mr-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "confirmed-shift mr-1" }, null, -1)
const _hoisted_13 = { class: "overflow-auto" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-down" }, null, -1)
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "relative h-full -m-1" }
const _hoisted_20 = { class: "h-full items-center justify-center flex text-white" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('workingOrganizationName')) + ":", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.myAccount.unit_name), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('staffName')) + ":", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.myAccount.employee_name), 1)
      ]),
      _hoisted_7
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_DatePicker, {
        "onUpdate:modelValue": [
          _ctx.selectTargetMonth,
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewConfirmSearchParams.target_month = $event))
        ],
        modelValue: _ctx.viewConfirmSearchParams.target_month,
        type: "month",
        "is-icon-chevron-left": "",
        "is-icon-chevron-right": "",
        format: "YYYY-MM"
      }, null, 8, ["onUpdate:modelValue", "modelValue"]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('hopeShift')), 1),
        _hoisted_12,
        _createVNode("div", null, _toDisplayString(_ctx.t('fixedShift')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_Table, {
        headers: _ctx.shiftRegisterDataHeader,
        data: _ctx.viewConfirmShiftList
      }, {
        date: _withId(({ item }) => [
          _createVNode("div", {
            style: { color: _ctx.getColorDate(item.target_date) },
            class: "text-center"
          }, _toDisplayString(_ctx.displayDate(item.target_date)), 5)
        ]),
        employee_expect_type: _withId(({ item }) => [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.displayExpectType(
                item.shift_plan_employee_date?.employee_expect_type,
                item.shift_plan_employee_date?.expect_shift_pattern_id,
                item.shift_plan_employee_date?.expect_shift_pattern_name
              )), 1)
        ]),
        employee_expect_work_time: _withId(({ item }) => [
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.displayTargetTime(
                item.shift_plan_employee_date?.employee_expect_work_start_time,
                item.shift_plan_employee_date?.employee_expect_work_end_time
              )), 1)
        ]),
        manager_confirm_type: _withId(({ item }) => [
          (
              _ctx.isShowManagerExpertType(
                item.shift_plan_employee_date?.manager_confirm_type
              )
            )
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "text-center flex expert-type items-center",
                style: {
              background: _ctx.getBackgroundExpertType(
                item.shift_plan_employee_date?.manager_confirm_type
              ),
            }
              }, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.displayExpectType(
                  item.shift_plan_employee_date?.manager_confirm_type,
                  item.shift_plan_employee_date?.confirmed_shift_pattern_id,
                  item.shift_plan_employee_date?.confirmed_shift_pattern_name
                )), 1),
                _hoisted_17
              ], 4))
            : _createCommentVNode("", true)
        ]),
        manager_confirm_work_time: _withId(({ item }) => [
          _createVNode("div", _hoisted_18, _toDisplayString(_ctx.displayTargetTime(
                item.shift_plan_employee_date?.manager_confirm_work_start_time,
                item.shift_plan_employee_date?.manager_confirm_work_end_time
              )), 1)
        ]),
        time_min: _withId(({ item }) => [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", {
              class: "time-line time-line-manager-confirmed",
              style: 
                _ctx.styleTimeLine(
                  item.shift_plan_employee_date
                    ?.manager_confirm_work_start_time,
                  item.shift_plan_employee_date?.manager_confirm_work_end_time
                )
              
            }, [
              _createVNode("div", _hoisted_20, [
                _createVNode("span", null, _toDisplayString(_ctx.displayManagerConfirmWorkTime(item.shift_plan_employee_date)), 1)
              ])
            ], 4),
            _createVNode("div", {
              class: "time-line time-line-employee-expert",
              style: 
                _ctx.styleTimeLine(
                  item.shift_plan_employee_date
                    ?.employee_expect_work_start_time,
                  item.shift_plan_employee_date?.employee_expect_work_end_time
                )
              
            }, null, 4)
          ])
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ])
  ]))
})